import React, { Component } from "react";
import { connect } from "react-redux";
import {
  View,
  StyleSheet,
  TouchableHighlight,
  TouchableOpacity,
  KeyboardAvoidingView,
  ScrollView,
  Dimensions,
} from "react-native";
import Switch from "../components/ToggleSwitch";
import Text from "../components_v2/TextFont";
import * as Actions from "../actions/CameraActions";
import { translate } from "../locales/translate";
import ArButton from "../argon-ui/Button";
import Theme from "../argon-ui/Theme";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import {
  faTrash,
  faPlus,
  faEdit,
  faTimes,
  faCheckCircle,
  faDotCircle,
  faLockAlt,
} from "../../assets/consts/faCharCodes";
import * as DeviceTypes from "../components/devices/_deviceTypes";
import PropTypes from "prop-types";
import Loading from "../components/Loading";
import { SimpleIcon } from "../components_v2/Buttons";
import InputBase from "../nativeBase-ui/InputBase";
import { HStack } from "native-base";
import Select from "../nativeBase-ui/Select";
import ModalBase from "../nativeBase-ui/ModalBase";
import { getIsRTL } from "../util";

const PROTOCOLS = {
  HTTP: "http",
  RTSP: "rtsp",
};

/**@augments{Component<props,state>} */
class CameraChannel extends Component {
  static propTypes = {
    id: PropTypes.number,
    name: PropTypes.string,
    channel: PropTypes.string,
    isDefault: PropTypes.bool,
    onNameChange: PropTypes.func,
    onChannelChange: PropTypes.func,
    onDefaultChange: PropTypes.func,
    onDelete: PropTypes.func,
  };
  constructor(props) {
    super(props);
    let { id, name, channel, isDefault } = props;
    this.state = {
      id,
      name,
      channel,
      isDefault,
    };
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.DeviceList"),
  });
  handleOnNameChange = (name) => {
    this.setState({ name }, () => {
      this.props.onNameChange && this.props.onNameChange(name);
    });
  };
  handleOnChannelChange = (channel) => {
    this.setState({ channel }, () => {
      this.props.onChannelChange && this.props.onChannelChange(channel);
    });
  };
  handleOnDefaultChange = (isDefault) => {
    this.setState({ isDefault }, () => {
      this.props.onDefaultChange && this.props.onDefaultChange(isDefault);
    });
  };
  handleOnDelete = () => {
    this.setState({ id: 0, name: "", channel: "", isDefault: false });
    this.props.onDelete && this.props.onDelete(this.state.id);
  };

  render() {
    return (
      <View
        style={{
          flexDirection: "row",
          marginVertical: 5,
          padding: 5,
          alignItems: "center",
          borderColor: Theme.COLORS.BORDER_COLOR,
          borderWidth: 2,
          borderRadius: 10,
          backgroundColor: Theme.COLORS.WHITE,
        }}
      >
        <View style={{ flex: 1, padding: 5 }}>
          <InputBase
            inputStyle={{ backgroundColor: Theme.COLORS.LIGHT_MAIN }}
            placeholder={translate("camera.channelNameHint")}
            label={translate("camera.channelName")}
            onChangeText={(txt) => this.handleOnNameChange(txt)}
            value={this.state.name}
            icon={faEdit}
          />
          <View style={{ marginVertical: 25 }}>
            <InputBase
              inputStyle={{ backgroundColor: Theme.COLORS.LIGHT_MAIN }}
              placeholder=""
              label={translate("camera.channel")}
              onChangeText={(txt) => this.handleOnChannelChange(txt)}
              value={this.state.channel}
              icon={faEdit}
            />
          </View>

          <Switch
            label={translate("camera.isDefaultChannel")}
            isOn={this.props.isDefault || false}
            onColor={Theme.COLORS.ACTIVE}
            offColor={Theme.COLORS.MUTED}
            size="small"
            onToggle={(v) => {
              this.handleOnDefaultChange(v);
            }}
            animationSpeed={0}
          />
        </View>
        <View style={{ marginHorizontal: 10, paddingTop: 1 }}>
          <TouchableHighlight
            underlayColor="transparent"
            style={{
              width: 35,
              height: 35,
              backgroundColor: Theme.COLORS.ERROR,
              justifyContent: "center",
              alignItems: "center",
              borderRadius: 5,
            }}
            onPress={this.handleOnDelete}
          >
            <FontAwesomeIcon icon={faTrash} color="#FFF" size={16} />
          </TouchableHighlight>
        </View>
      </View>
    );
  }
}

class CameraFormScreen extends Component {
  constructor(props) {
    super(props);
    //let cameraId = undefined;
    let deviceId = undefined;
    let deviceUId = undefined;
    let areaId = undefined;
    let areaUId = undefined;
    if (this.props.navigation.state.params) {
      // cameraId = this.props.navigation.state.params.cameraId;
      deviceId = this.props.navigation.state.params.deviceId;
      deviceUId = this.props.navigation.state.params.deviceUId;
      areaId = this.props.navigation.state.params.areaId;
      areaUId = this.props.navigation.state.params.areaUId;
    }

    this.doorbellList = [];

    this._selectedDoorbell = "";
    this._selectedDoorbells = [];

    this.doorLockList = [
      {
        deviceId: null,
        deviceName: "---",
      },
    ];
    this._selectedDoorLock = "";

    this.state = {
      areaId,
      areaUId,
      deviceId,
      deviceUId,
      cameraId: 0,
      cameraUId: null,
      cameraName: "",
      protocol: PROTOCOLS.HTTP,
      rtspServerId: null,
      ip: "",
      port: "",
      channels: [{ id: 0, name: "", channel: "", isDefault: true }], // initialize with an empty channel
      userName: "",
      v380DeviceId: "",
      doorbellDeviceId: undefined,
      doorbellDeviceIds: [],
      doorLockDeviceId: undefined,
      hasDoorBell: false,
      serverUrl: "",
      accessToken: "",

      modified: false,
      // validation.
      validation_cameraName_hasError: false,
      validation_IP_hasError: false,

      isLoading: true,
      showDoorbellsModal: false,
      tempSelectedDoorbells: [],
      rtspServers: [],
    };
  }

  init = async () => {
    var model = {};
    let { deviceId, deviceUId } = this.state;
    if (deviceUId) {
      for (var i in this.props.reducer.list) {
        let dvc = this.props.reducer.list[i];
        if (dvc && dvc.deviceUId == deviceUId) {
          model = dvc;
          break;
        }
      }
    } else if (deviceId) {
      for (var i in this.props.reducer.list) {
        let dvc = this.props.reducer.list[i];
        if (dvc && dvc.deviceId == deviceId) {
          model = dvc;
          break;
        }
      }
    }
    // console.log('model in CameraFormScreen', model)
    let {
      cameraName,
      protocol,
      ip,
      port,
      channels,
      userName,
      cameraId,
      cameraUId,
      v380DeviceId,
      doorbellDeviceId,
      doorbellDeviceIds,
      doorLockDeviceId,
      rtspServerId,
    } = model;
    // normalize arrays
    if (!Array.isArray(doorbellDeviceIds)) doorbellDeviceIds = [];

    if (!channels || !Array.isArray(channels) || channels.length == 0) {
      // initialize with an empty channel
      channels = [{ id: 0, name: "", channel: "", isDefault: true }];
    }
    // console.log("model in CameraFormScreen", model);

    for (var i in this.props.reducer.list) {
      var dvc = this.props.reducer.list[i];

      // initialize doorbellList
      if (dvc.deviceType == DeviceTypes.DOORBELL) {
        // single doorbell mode for backward compatibility
        if (dvc.deviceId == doorbellDeviceId) {
          this._selectedDoorbell = dvc.deviceName;
        }
        // current mode(multiple doorbell)
        else if (doorbellDeviceIds.includes(dvc.deviceId)) {
          this._selectedDoorbells.push(dvc.deviceName);
        }
        if (
          dvc.cameraId == null || // get list of doorbells that not attached yet
          dvc.deviceId == doorbellDeviceId || // include current entity
          doorbellDeviceIds.includes(dvc.deviceId)
        ) {
          this.doorbellList.push({
            deviceId: dvc.deviceId,
            deviceName: dvc.deviceName,
          });
        }
      }

      // initialize doorLockList
      else if (dvc.deviceType == DeviceTypes.DOORLOCK) {
        if (dvc.deviceId == doorLockDeviceId) {
          this._selectedDoorLock = dvc.deviceName;
        }
        if (
          dvc.cameraId == null || // get list of doorbells that not attached yet
          dvc.deviceId == doorLockDeviceId // include current entity
        ) {
          this.doorLockList.push({
            deviceId: dvc.deviceId,
            deviceName: dvc.deviceName,
          });
        }
      }
    }

    let hasDoorBell = false;
    if (doorbellDeviceId || doorbellDeviceIds.length) hasDoorBell = true;
    var rtspServers = await this.getRtspServers();
    this.setState({
      cameraName,
      protocol: protocol || PROTOCOLS.HTTP,
      ip,
      port,
      channels,
      userName,
      cameraId,
      cameraUId,
      v380DeviceId,
      doorbellDeviceId,
      doorbellDeviceIds,
      doorLockDeviceId,
      hasDoorBell,
      rtspServers,
      rtspServerId: rtspServerId || null,
      isLoading: false,
    });
  };

  getRtspServers = async () => {
    let { currentServer, currentBuilding, serverUrl } = this.props.appReducer;
    const buildingId = currentBuilding.buildingId;
    var api = serverUrl;
    if (!api.endsWith("/")) api += "/";
    api += `Camera/RTSPServers?buildingId=${buildingId}`;
    var rtspServers = [];
    try {
      var response = await fetch(api, {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.state.accessToken}`,
        },
      });
      if (response.ok) rtspServers = await response.json();
    } catch (error) {
      console.log(`error on get rtspServers from ${api}`, error);
    }

    return rtspServers;
  };

  componentDidMount() {
    let { currentServer, serverUrl } = this.props.appReducer;
    this.setState(
      {
        serverUrl,
        accessToken: currentServer.accessToken,
      },
      () => {
        this.init();
      }
    );
  }

  goBack = () => {
    this.props.navigation.goBack(); //.navigate("Cameras");

    // callback
    this.props.navigation.state.params.onGoBack &&
      this.props.navigation.state.params.onGoBack(DeviceTypes.CAMERA);
  };

  save = () => {
    let {
      areaId,
      areaUId,
      cameraId,
      cameraUId,
      cameraName,
      protocol,
      ip,
      port,
      channels,
      v380DeviceId,
      userName,
      passwordHash,
      doorbellDeviceId,
      doorbellDeviceIds,
      doorLockDeviceId,
      rtspServerId,
    } = this.state;
    var model = {
      areaId,
      areaUId,
      cameraId,
      cameraUId,
      cameraName,
      protocol,
      ip,
      port,
      rtspServerId,
      channels,
      v380DeviceId,
      userName,
      passwordHash,
      doorbellDeviceId,
      doorbellDeviceIds,
      doorLockDeviceId,
      buildingId: this.props.appReducer.currentBuilding.buildingId,
    };

    let errors = [];

    // validation
    if (!model.cameraName) {
      errors.push(
        `${translate("camera.cameraName")} ${translate("app.isRequired")}`
      );
      this.setState({ validation_cameraName_hasError: true });
    }

    if (!model.ip) {
      errors.push(`${translate("camera.ip")} ${translate("app.isRequired")}`);
      this.setState({ validation_IP_hasError: true });
    }

    if (model.protocol == PROTOCOLS.RTSP && !model.rtspServerId) {
      errors.push(
        `${translate("camera.rtspServer")} ${translate("app.isRequired")}`
      );
    }

    if (errors.length > 0) {
      alert(errors.join("\r\n"));
      return;
    }
    // end of validation

    if (model.cameraUId || model.cameraId) {
      // dispatch update action
      this.props.update(model, this.state.accessToken);
    } else {
      // try insert new
      this.props.add(model, this.state.accessToken);
    }
    // then go back to list
    this.goBack();
  };

  getFullUriPreview = (channelName, channel) => {
    let uri = "",
      credential = "",
      _port = ":554";
    if (this.state.userName && this.state.passwordHash) {
      var _password = this.state.passwordHash.replace(/./g, "*");
      credential = `${this.state.userName}:${_password}@`;
    }

    if (this.state.port) {
      _port = ":" + this.state.port;
    }

    if (this.state.ip) {
      //let sch = this.state.v380DeviceId ? "http://" : "rtsp://";
      uri = `${this.state.protocol}://${credential}${this.state.ip}${_port}${
        channel || this.state.channel || ""
      }`;
    }
    var hasName = true;
    if (channelName == undefined || channelName == null || channelName == "") {
      hasName = false;
    }
    return (
      <View style={{ flexDirection: "row", marginBottom: 10 }}>
        <Text style={{}}>
          {hasName && (
            <Text style={{ fontWeight: "bold" }}>{channelName} :</Text>
          )}
          {uri}
        </Text>
      </View>
    );
    //return uri;
  };

  handleOnHasDoorBellValueChange = (value) => {
    this.setState({ hasDoorBell: value });
  };

  showDoorbellsModal = () => {
    this.setState({
      showDoorbellsModal: true,
      tempSelectedDoorbells: [...this.state.doorbellDeviceIds],
    });
  };

  hideDoorbellsModal = () => {
    this.setState({
      showDoorbellsModal: false,
      tempSelectedDoorbells: [],
    });
  };

  applyDoorbellsChange = () => {
    var doorbellDeviceIds = [...this.state.tempSelectedDoorbells];
    this.setState({
      showDoorbellsModal: false,
      doorbellDeviceIds,
      tempSelectedDoorbells: [],
    });
  };

  removeSelectedDoorbell = (doorbellDeviceId) => {
    let { doorbellDeviceIds } = this.state;
    var idx = doorbellDeviceIds.indexOf(doorbellDeviceId);
    if (idx >= 0) {
      doorbellDeviceIds.splice(idx, 1);
      this.setState({
        doorbellDeviceIds: [...doorbellDeviceIds],
      });
    }
  };

  render() {
    const screenTitle =
      this.state.cameraUId || this.state.cameraId
        ? this.state.cameraName || translate("app.noName")
        : translate("camera.createNewCamera");

    if (this.state.isLoading) {
      return <Loading />;
    }

    return (
      <KeyboardAvoidingView
        behavior="height"
        style={{ flex: 1 }}
        enabled={true}
        keyboardVerticalOffset={80}
      >
        <ScrollView style={style.container}>
          <Text style={style.screenTitle}>{screenTitle}</Text>
          <View style={{ color: Theme.COLORS.MUTED, textAlign: "center" }}>
            {this.state.channels.map((chn, idx) => {
              return (
                <View
                  key={idx}
                  style={{
                    writingDirection: "ltr",
                    alignItems: getIsRTL() ? "flex-end" : "flex-start",
                  }}
                >
                  {this.getFullUriPreview(chn.name, chn.channel)}
                </View>
              );
            })}
          </View>

          {/* camera name */}
          <InputBase
            containerStyle={{ marginBottom: 10 }}
            label={translate("camera.cameraName")}
            isInvalid={this.state.validation_cameraName_hasError}
            value={this.state.cameraName}
            onChangeText={(txt) =>
              this.setState({
                cameraName: txt,
                validation_cameraName_hasError: txt.length == 0,
              })
            }
            icon={faEdit}
          />
          {/* end camera name */}
          {/* url protocol */}
          <Select
            label={translate("camera.protocol")}
            data={[
              { value: PROTOCOLS.HTTP, label: PROTOCOLS.HTTP },
              { value: PROTOCOLS.RTSP, label: PROTOCOLS.RTSP },
            ]}
            value={this.state.protocol || PROTOCOLS.HTTP}
            onChangeText={(value, index, data) => {
              this.setState({ protocol: value });
            }}
          />
          {/* end url protocol */}

          {/* rtsp servers */}
          {this.state.protocol == PROTOCOLS.RTSP &&
            this.state.rtspServers.length > 0 && (
              <Select
                label={translate("camera.rtspServer")}
                data={this.state.rtspServers.map((s) => {
                  return {
                    value: s.id,
                    label: s.friendlyName || s.uri,
                  };
                })}
                value={this.state.rtspServerId}
                onChangeText={(value, index, data) => {
                  this.setState({ rtspServerId: value });
                }}
              />
            )}
          {/* end rtsp servers */}

          {/* camera ip */}
          <View style={{ marginVertical: 30 }}>
            <InputBase
              keyboardType="numeric"
              label={translate("camera.ip")}
              isInvalid={this.state.validation_IP_hasError}
              onChangeText={(txt) =>
                this.setState({
                  ip: txt,
                  validation_IP_hasError: txt.length == 0,
                  modified: true,
                })
              }
              value={this.state.ip}
              icon={faEdit}
            />
          </View>
          {/* end camera ip */}
          {/* camera port */}
          <InputBase
            keyboardType="numeric"
            placeholder=""
            label={translate("camera.port")}
            isInvalid={this.state.validation_IP_hasError}
            onChangeText={(txt) =>
              this.setState({
                port: Number(txt) || null,
                modified: true,
              })
            }
            value={this.state.port}
            icon={faEdit}
          />
          {/* end camera port */}
          {/* camera channels */}
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <Text
              style={{
                height: 30,
                textAlignVertical: "center",
                paddingTop: 12,
              }}
            >
              {translate("camera.channels")}
            </Text>
            <ArButton
              color="success"
              style={{
                width: 100,
                height: 30,
                alignSelf: "flex-start",
                marginEnd: 5,
                marginStart: 10,
                marginTop: 15,
              }}
              onPress={() => {
                let { channels } = this.state;
                channels.push({
                  id: 0,
                  name: "",
                  channel: "",
                  isDefault: false,
                });
                this.setState({ channels });
              }}
            >
              <View
                style={{
                  flexDirection: "row-reverse",
                }}
              >
                <FontAwesomeIcon icon={faPlus} color="#FFF" />
              </View>
            </ArButton>
          </View>

          {this.state.channels.map((chn, idx) => {
            return (
              <CameraChannel
                key={idx}
                id={chn.id}
                name={chn.name}
                channel={chn.channel}
                isDefault={chn.isDefault || false}
                onNameChange={(name) => {
                  let _channels = [...this.state.channels];
                  _channels[idx].name = name;
                  this.setState({ channels: _channels });
                }}
                onChannelChange={(channel) => {
                  let _channels = [...this.state.channels];
                  _channels[idx].channel = channel;
                  this.setState({ channels: _channels });
                }}
                onDefaultChange={(isDefault) => {
                  let _channels = [...this.state.channels];
                  // if there is one channel, do not change flag to keep that single one as always true
                  if (_channels.length > 1 && isDefault) {
                    for (var jdx in _channels) {
                      if (idx == jdx) {
                        // set current as true
                        _channels[jdx].isDefault = isDefault;
                      } else {
                        // and set others as false
                        _channels[jdx].isDefault = false;
                      }
                    }
                  }

                  this.setState({ channels: _channels });
                }}
                onDelete={() => {
                  let _channels = [...this.state.channels];
                  _channels.splice(idx, 1);
                  if (_channels.length == 0) {
                    _channels = [
                      { id: 0, name: "", channel: "", isDefault: true },
                    ];
                  } else if (_channels.length == 1) {
                    _channels[0].isDefault = true;
                  }
                  this.setState({ channels: _channels });
                }}
              />
            );
          })}
          {/* end camera channels */}
          <Text
            style={{
              color: Theme.COLORS.MUTED,
              fontSize: 20,
              paddingTop: 20,
              fontWeight: "bold",
            }}
          >
            {translate("camera.connectionInfo")}
          </Text>
          {/* camera v380 deviceId */}
          <View style={{ marginTop: 15 }}>
            <InputBase
              keyboardType="numeric"
              placeholder=""
              label={translate("camera.v380DeviceId")}
              onChangeText={(txt) =>
                this.setState({
                  v380DeviceId: txt,
                  modified: true,
                })
              }
              value={this.state.v380DeviceId}
              icon={faEdit}
            />
          </View>
          {/* end camera v380 deviceId */}
          {/* camera userName */}
          <View style={{ marginVertical: 30 }}>
            <InputBase
              placeholder=""
              label={translate("camera.userName")}
              onChangeText={(txt) =>
                this.setState({
                  userName: txt,
                  modified: true,
                })
              }
              value={this.state.userName}
              icon={faEdit}
            />
          </View>
          {/* end camera userName */}
          {/* camera password */}
          <InputBase
            type="password"
            placeholder=""
            label={translate("camera.password")}
            onChangeText={(txt) =>
              this.setState({
                passwordHash: txt,
                modified: true,
              })
            }
            value={this.state.passwordHash}
            icon={faLockAlt}
          />
          {/* end camera password */}

          {/* connected to door bell */}
          {this.doorbellList.length > 0 && (
            <View style={{ flexDirection: "row" }}>
              <Switch
                isOn={this.props.hasDoorBell}
                onColor={Theme.COLORS.ACTIVE}
                offColor={Theme.COLORS.MUTED}
                size="small"
                onToggle={this.handleOnHasDoorBellValueChange}
                animationSpeed={0}
              />
              <Text>{translate("camera.hasDoorbell")}</Text>
            </View>
          )}
          {/* end connected to door bell */}

          {/* door bells list */}
          {this.state.hasDoorBell && this.doorbellList.length > 0 && (
            <View style={style.dropdownWrapper}>
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  marginBottom: 10,
                }}
              >
                <Text>{translate("camera.doorbellList")}</Text>
                <TouchableHighlight
                  style={{
                    marginStart: 10,
                    padding: 5,
                    backgroundColor: Theme.COLORS.SUCCESS,
                    //   borderWidth: 1,
                    borderRadius: 3,
                  }}
                  underlayColor={Theme.COLORS.SUCCESS}
                  onPress={this.showDoorbellsModal}
                >
                  <Text>
                    <FontAwesomeIcon
                      color={Theme.COLORS.WHITE}
                      icon={
                        this.state.doorbellDeviceIds.length == 0
                          ? faPlus
                          : faEdit
                      }
                    />
                  </Text>
                </TouchableHighlight>
              </View>
              <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
                {this.doorbellList
                  .filter(
                    (dr) =>
                      Array.isArray(this.state.doorbellDeviceIds) &&
                      this.state.doorbellDeviceIds.includes(dr.deviceId)
                  )
                  .map((dr, drIdx) => {
                    return (
                      <View key={drIdx} style={style.doorbellItem}>
                        <TouchableHighlight
                          style={[
                            style.doorbellItem,
                            {
                              backgroundColor: "#fff",
                              height: 22,
                              marginEnd: 6,
                              marginStart: 0,
                              alignSelf: "flex-start",
                            },
                          ]}
                          underlayColor="#ff5252"
                          onPress={() =>
                            this.removeSelectedDoorbell(dr.deviceId)
                          }
                        >
                          <FontAwesomeIcon icon={faTimes} color="#ff5252" />
                        </TouchableHighlight>
                        <Text style={{ paddingHorizontal: 10 }}>
                          {dr.deviceName}
                        </Text>
                      </View>
                    );
                  })}
              </View>
            </View>
          )}
          {/* end door bells list */}

          {/* door locks list */}
          {this.state.hasDoorBell && this.doorLockList.length > 1 && (
            <View style={style.dropdownWrapper}>
              <Select
                label={translate("camera.doorLockList")}
                data={this.doorLockList.map((v) => {
                  return { value: v.deviceId, label: v.deviceName };
                })}
                value={this._selectedDoorLock}
                onChangeText={(value, index, data) => {
                  this.setState({
                    doorLockDeviceId: value,
                  });
                }}
              />
            </View>
          )}
          {/* end door locks list */}

          <HStack
            space={2}
            style={{
              marginTop: 25,
              marginBottom: 10,
            }}
          >
            <ArButton
              color="primary"
              onPress={() => this.save()}
              style={{ flex: 1, marginBottom: 0 }}
            >
              {translate("app.save")}
            </ArButton>
            <ArButton
              color="muted"
              variant="outline"
              onPress={() => this.goBack()}
              style={{ flex: 1, marginBottom: 0 }}
            >
              {translate("app.goBack")}
            </ArButton>
          </HStack>
        </ScrollView>
        {/** select doorbells modal */}
        {this.state.showDoorbellsModal && (
          <ModalBase
            avoidKeyboard={true}
            isOpen={this.state.showDoorbellsModal}
            onClose={this.hideDoorbellsModal}
            contentStyle={{ height: "100%" }}
          >
            <View style={style.modalWrapper}>
              <ScrollView style={{ flex: 1 }}>
                <Text
                  style={{
                    fontSize: 18,
                    fontWeight: "bold",
                    marginVertical: 15,
                    textAlign: "center",
                  }}
                >
                  {translate("camera.doorbellList")}
                </Text>
                {this.doorbellList.map((e, i) => {
                  var isSelected = this.state.tempSelectedDoorbells.includes(
                    e.deviceId
                  );

                  return (
                    <TouchableOpacity
                      key={i}
                      style={{
                        flexDirection: "row",
                        justifyContent: "flex-start",
                      }}
                      onPress={() => {
                        let { tempSelectedDoorbells } = this.state;
                        var idx = tempSelectedDoorbells.indexOf(e.deviceId);
                        if (idx >= 0) {
                          tempSelectedDoorbells.splice(idx, 1);
                        } else {
                          tempSelectedDoorbells.push(e.deviceId);
                        }
                        this.setState({
                          tempSelectedDoorbells: [...tempSelectedDoorbells],
                        });
                      }}
                    >
                      <SimpleIcon
                        icon={isSelected ? faCheckCircle : faDotCircle}
                        size={18}
                        color={
                          isSelected ? Theme.COLORS.SUCCESS : Theme.COLORS.BLACK
                        }
                        style={style.deviceListItemIcon}
                      />
                      <Text style={style.deviceListItem}>{e.deviceName}</Text>
                    </TouchableOpacity>
                  );
                })}
              </ScrollView>
              <HStack space="2">
                <ArButton
                  color="primary"
                  onPress={this.applyDoorbellsChange}
                  style={style.btnSubmit}
                >
                  {translate("app.confirm")}
                </ArButton>
                <ArButton
                  variant="outline"
                  color="muted"
                  onPress={this.hideDoorbellsModal}
                  style={style.btnSubmit}
                >
                  {translate("app.cancel")}
                </ArButton>
              </HStack>
            </View>
          </ModalBase>
        )}
      </KeyboardAvoidingView>
    );
  }
}

const btnStyle = {
  flex: 1,
  margin: 3,
  padding: 3,
  borderRadius: 3,
  height: 45,
  alignItems: "center",
  justifyContent: "center",
};

const style = StyleSheet.create({
  container: {
    paddingTop: 20,
    paddingHorizontal: 10,
  },
  screenTitle: {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 26,
  },
  img: {
    borderColor: "#eee",
    borderWidth: 1,
    borderRadius: 15,
    // marginHorizontal: 'auto',
    marginVertical: 5,
    resizeMode: "cover",
    alignSelf: "center",
    width: Dimensions.get("window").width,
    height: Dimensions.get("window").width * (9 / 16),
  },
  txtInput: {
    borderWidth: 1,
    borderColor: "navy",
  },
  btnPickImage: {
    ...btnStyle,
    borderWidth: 1,
    borderColor: "#ddd",
    backgroundColor: "#FFF",
    width: "100%",
  },
  btnPickImageAr: {
    // marginVertical: 3
    height: 45,
  },
  btnPickImageGroup_Show: {
    position: "absolute",
    flex: 1,
    alignItems: "center",
    width: "100%",
    height: "100%",
    paddingVertical: 10,
    justifyContent: "space-around",
    backgroundColor: "#FFFA",
  },
  btnPickImageGroup_Hide: {
    display: "none",
  },
  modalWrapper: {
    flex: 1,
    padding: 10,
  },
  btnSubmitHolder: {
    flexDirection: "row",
    paddingHorizontal: 5,
  },
  btnSubmit: {
    flex: 1,
    marginBottom: 0,
    //width: "90%",
  },
  deviceListItemIcon: {
    textAlignVertical: "center",
    height: 42,
    marginStart: 20,
  },
  deviceListItem: {
    flex: 1,
    height: 42,
    borderBottomColor: Theme.COLORS.BORDER_COLOR,
    borderBottomWidth: 1,
    textAlignVertical: "center",
    marginStart: 5,
  },
  btnDevices: {
    flex: 1,
    marginTop: 10,
    width: "100%",
  },
  dropdownWrapper: { marginTop: 16 },
  dropdownButton: {
    width: "100%",
    backgroundColor: "#FFF",
    borderColor: Theme.COLORS.BORDER,
    borderWidth: 1,
    marginTop: 6,
    shadowColor: Theme.COLORS.BLACK,
    shadowOffset: { width: 0, height: 1 },
    shadowRadius: 2,
    shadowOpacity: 0.05,
    elevation: 2,
  },
  doorbellItem: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "#ffe6e6",
    borderColor: "#ff5252",
    borderWidth: 1,
    height: 32,
    padding: 3,
    marginHorizontal: 10,
    borderRadius: 16,
  },
  dropdownButtonText: { color: "#000", paddingVertical: 5 },
  dropdownMenu: { width: "80%", elevation: 3 },
  dropdownMenuText: { paddingVertical: 22 },
});

const mapStateToProps = (state) => {
  // console.log('state', state.AppReducer)
  return {
    reducer: state.DeviceReducer,
    appReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    add: (model, accessToken) => {
      dispatch(Actions.Add(model, accessToken));
    },
    update: (model, accessToken) => {
      dispatch(Actions.Update(model, accessToken));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CameraFormScreen);
